import { useEffect } from 'react';
import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { useAppSelector } from '@store';
import ExportBatchesColumn from '../../components/export-column/column-batches';
import {
  useLazyGetExportBatchesQuery,
  useLazyGetExportOutgoingTransactionsCountQuery,
} from './store/services';

import cn from './styles.module.css';

const ExportBatches = (): React.JSX.Element => {
  const { bankId } = useParams();

  const {
    batches,
    countNewTransactions,
    accountNumber,
    accountId,
    batchesPagination,
  } = useAppSelector((state) => state.export.batches);

  const [getBatchesList, { isLoading, isFetching }] =
    useLazyGetExportBatchesQuery();

  const [
    getTransactionsList,
    { isLoading: transactionsIsLoading, isFetching: transactionsIsFetching },
  ] = useLazyGetExportOutgoingTransactionsCountQuery();

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  const getNextPage = (cursor: string, take: string) => {
    getBatchesList({
      pspPartnerId: bankId as string,
      pspAccountId: accountId as string,
      take,
      cursor,
    });
  };

  useEffect(() => {
    if (accountId && bankId && accountNumber) {
      getBatchesList({
        pspPartnerId: bankId,
        pspAccountId: accountId,
        take: '15',
      });
      getTransactionsList({
        pspPartnerId: bankId,
        pspPartnerAccountNumber: accountNumber,
      });
    }
  }, [accountId, accountNumber, bankId]);

  return (
    <>
      <div className={cn.columnWrapper}>
        <ExportBatchesColumn
          count={countNewTransactions}
          sentBatches={batches}
          bankId={bankId}
          accountId={accountId}
          pagination={batchesPagination}
          isLoading={
            isLoading ||
            isFetching ||
            transactionsIsLoading ||
            transactionsIsFetching
          }
          getNextPage={getNextPage}
        />
      </div>
      <Outlet context={{ sendMessage }} />
    </>
  );
};

export default ExportBatches;
